import EventBus from '@/utile/eventBus'
// app
// state
const state = {
  filterState: { // 매물타입, 매물유형, 방구조, 거래유형, 가격, 관리비여부, 방크기, 층수, 준공년차, 추가옵션
    search: '',
    viewType: 'tab-1', // 1: 전체, 2: 외관, 3: 실시간
    itemType: { // 1: 원룸, 2: 투룸, 3: 쓰리룸+, 4: 빌라분양/매매, 5: 상가/사무실
      opt1: 1,
      opt2: 1,
      opt3: 1,
      opt4: 0,
      opt5: 0
    },
    structType: { // 원룸 (0: 오픈형, 1: 복층, 2: 주방분리형, 3: 주방거실형) 투,쓰리룸(6: 거실소, 7: 거실중, 8: 거실대)
      opt0: 1,
      opt1: 1,
      opt2: 1,
      opt3: 1,
      opt4: 1,
      opt5: 1,
      opt6: 1,
      opt7: 1,
      opt8: 1
    },
    saleType: { // 1: 월세, 2: 전세, 3: 매매
      opt1: 1,
      opt2: 1,
      opt3: 1
    },
    depositStep: [0, 44],
    deposit: [0, -1], // 보증금 전세
    monthlyStep: [0, 30],
    monthly: [0, -1], // 월세
    salePriceStep: [0, 25],
    salePrice: [0, -1], // 매매가
    mCost: 0, // 관리비 포함여부
    m2Step: [0, 10],
    m2: [0, -1], // 방크기 m2
    itemFloor: { // 1: 지상층, 8: 반지층, 9: 옥탑
      opt1: 1,
      opt8: 1,
      opt9: 1
    },
    approvalDate: 0, // 0: 전체, 1: 1년이내, 2: 5년이내, 3: 10년이내, 4: 15년이내, 5: 15년이상
    roomOption: { // 1: 발코니, 2: 빌트인, 3: 동물가능여부, 4: 전세자금대출 여부, 5: 비옵션
      opt1: 0,
      opt2: 0,
      opt3: 0,
      opt4: 0,
      opt5: 0
    },
    imgOption: { // 이미지 보기 옵션
      opt1: 0, // 동영상
      opt2: 0, // 사진
      opt3: 0, // 2D
      opt4: 0, // 3D
      opt5: 0 // VR
    },
    listCount: 0,
    totCount: 0,
    target: {
      selected: false,
      type: '', // point range, radius
      no: '',
      minLat: 0,
      maxLat: 0,
      minLng: 0,
      maxLng: 0,
      lat: 0,
      lng: 0,
      radius: 0,
      listCount: 0,
      totCount: 0
    }
  },
  detailView: {
    show: false,
    type: '',
    no: 0,
    viewList: [],
    viewMode: 'all',
    data: [],
    position: {x: 0, y: 0}
  },
  modifView: {
    show: false,
    type: 'r',
    title: '',
    src: '',
    btDel: false,
    btUpdate: false
  },
  iframeView: {
    show: false,
    type: 'r',
    title: '',
    src: '',
    btDel: false,
    btUpdate: false,
    tab: 'iframeview-tab-1'
  },
  mapObject: null,
  itemListData: [],
  itemListOverUpdateCancel: false,
  itemListOverMarkerId: null,
  favoriteView: {
    show: false,
    data: []
  },
  favoriteList: [],
  searchAutoView: {
    show: false,
    data: []
  }
}
// 보/전 45개 옵션 0~44
const depositStepText = ['0 원', '100만 원', '200만 원', '300만 원', '400만 원', '500만 원', '1천만 원', '1.5천만 원', '2천만 원', '2.5천만 원', '3천만 원', '3.5천만 원', '4천만 원', '4.5천만 원', '5천만 원', '6천만 원', '7천만 원', '8천만 원', '9천만 원', '1억', '1.1억 원', '1.2억 원', '1.3억 원', '1.4억 원', '1.5억 원', '1.6억 원', '1.7억 원', '1.8억 원', '1.9억 원', '2억 원', '2.5억 원', '3억 원', '3.5억 원', '4억 원', '4.5억 원', '5억 원', '5.5억 원', '6억 원', '6.5억 원', '7억 원', '7.5억 원', '8억 원', '8.5억 원', '9억 원', '무제한']
const depositPoint = [0, 100, 200, 300, 400, 500, 1000, 1.5000, 2000, 2.5000, 3000, 3.5000, 4000, 4.5000, 5000, 6000, 7000, 8000, 9000, 10000, 11000, 12000, 13000, 14000, 15000, 16000, 17000, 18000, 19000, 20000, 25000, 30000, 35000, 40000, 45000, 50000, 55000, 60000, 65000, 70000, 75000, 80000, 85000, 90000, -1]
// 월세 30개 옵션 0~29
const monthlyStepText = ['0 원', '5만 원', '10만 원', '15만 원', '20만 원', '25만 원', '30만 원', '35만 원', '40만 원', '45만 원', '50만 원', '55만 원', '60만 원', '65만 원', '70만 원', '80만 원', '90만 원', '100만 원', '110만 원', '120만 원', '130만 원', '140만 원', '150만 원', '160만 원', '170만 원', '180만 원', '190만 원', '200만 원', '250만 원', '300만 원', '무제한']
const monthlyPoint = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 250, 300, -1]
// 매매 26개 0~25
const salePriceStepText = ['0 원', '5천만 원', '1억 원', '1.5억 원', '2억 원', '2.5억 원', '3억 원', '3.5억 원', '4억 원', '4.5억 원', '5억 원', '6억 원', '7억 원', '8억 원', '9억 원', '10억 원', '11억 원', '12억 원', '13억 원', '14억 원', '15억 원', '16억 원', '17억 원', '18억 원', '19억 원', '무제한']
const salePricePoint = [0, 5000, 10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000, 50000, 60000, 70000, 80000, 90000, 100000, 110000, 120000, 130000, 140000, 150000, 160000, 170000, 180000, 190000, -1]
// 면적 11개 0~10
const m2StepText = ['0㎡(0평)', '26㎡(8평)', '40㎡(12평)', '53㎡(16평)', '66㎡(20평)', '79㎡(24평)', '93㎡(28평)', '106㎡(32평)', '119㎡(36평)', '132㎡(40평)', '무제한']
const m2Point = [0, 26, 40, 53, 66, 79, 93, 106, 119, 132, -1]

// getters
const getters = { // get 개념
  // 디테일 뷰
  getDetailViewList: (state) => {
    if (state.detailView.data.imgItemArray || state.detailView.data.img2dArray || state.detailView.data.img3dArray || state.detailView.data.imgVideoArray) {
      if (state.detailView.viewMode === 'all') {
        state.detailView.viewList = []
        state.detailView.viewList = state.detailView.viewList.concat(state.detailView.data.imgVideoArray, state.detailView.data.imgItemArray, state.detailView.data.img2dArray, state.detailView.data.img3dArray)
      } else if (state.detailView.viewMode === 'item') {
        state.detailView.viewList = state.detailView.data.imgItemArray
      } else if (state.detailView.viewMode === '2d') {
        state.detailView.viewList = state.detailView.data.img2dArray
      } else if (state.detailView.viewMode === '3d') {
        state.detailView.viewList = state.detailView.data.img3dArray
      } else if (state.detailView.viewMode === 'video') {
        state.detailView.viewList = state.detailView.data.imgVideoArray
      }
    }
    console.log(JSON.stringify(state.detailView.viewList))
    return state.detailView.viewList
  },
  getDetailViewSize: (state) => {
    if (state.detailView.data.imgItemArray || state.detailView.data.img2dArray || state.detailView.data.img3dArray || state.detailView.data.imgVideoArray) {
      if (state.detailView.viewMode === 'all') {
        return state.detailView.data.imgItemArray.length + state.detailView.data.img2dArray.length + state.detailView.data.img3dArray.length + state.detailView.data.imgVideoArray.length
      } else if (state.detailView.viewMode === 'item') {
        return state.detailView.data.imgItemArray.length
      } else if (state.detailView.viewMode === '2d') {
        return state.detailView.data.img2dArray.length
      } else if (state.detailView.viewMode === '3d') {
        return state.detailView.data.img3dArray.length
      } else if (state.detailView.viewMode === 'video') {
        return state.detailView.data.imgVideoArray.length
      }
    }
    return 0
  },
  // 아이템 리스트
  isFavorite: (state) => (no) => {
    return (state.favoriteList.indexOf(no) !== -1)
  },
  // 필터
  printDeposit: (state) => (min, max) => {
    state.filterState.deposit = [depositPoint[min], depositPoint[max]]
    return depositStepText[min] + '~' + depositStepText[max]
  },
  printMonthly: (state) => (min, max) => {
    state.filterState.monthly = [monthlyPoint[min], monthlyPoint[max]]
    return monthlyStepText[min] + '~' + monthlyStepText[max]
  },
  printSalePrice: (state) => (min, max) => {
    state.filterState.salePrice = [salePricePoint[min], salePricePoint[max]]
    return salePriceStepText[min] + '~' + salePriceStepText[max]
  },
  printM2: (state) => {
    state.filterState.m2 = [m2Point[state.filterState.m2Step[0]], m2Point[state.filterState.m2Step[1]]]
    return m2StepText[state.filterState.m2Step[0]] + '~' + m2StepText[state.filterState.m2Step[1]]
  },
  printM2Info: (state) => {
    return m2StepText[state.filterState.m2Step[0]] + '~' + m2StepText[state.filterState.m2Step[1]]
  },
  printPriceInfo: (state) => {
    let val = ''
    let dot1 = ''
    let dot2 = ''
    if (state.filterState.saleType.opt1 === 1 || state.filterState.saleType.opt2 === 2) {
      if (state.filterState.saleType.opt1 === 1) {
        val += dot1 + '보'
        dot1 = '/'
      }
      if (state.filterState.saleType.opt2 === 1) {
        val += dot1 + '전'
        dot1 = '/'
      }
      val += ': ' + (state.filterState.depositStep[0] === 0 ? '' : depositStepText[state.filterState.depositStep[0]] + '~') + depositStepText[state.filterState.depositStep[1]]
      dot2 = ', '
    }
    if (state.filterState.saleType.opt1 === 1) {
      val += dot2 + '월: ' + (state.filterState.monthlyStep[0] === 0 ? '' : monthlyStepText[state.filterState.monthlyStep[0]] + '~') + monthlyStepText[state.filterState.monthlyStep[1]]
      dot2 = ', '
    }
    if (state.filterState.saleType.opt3 === 1) {
      val += dot2 + '매: ' + (state.filterState.salePriceStep[0] === 0 ? '' : salePriceStepText[state.filterState.salePriceStep[0]] + '~') + salePriceStepText[state.filterState.salePriceStep[1]]
    }
    if (val === '') val = '거래유형'
    return val
  },
  printDateInfo: (state) => {
    switch (state.filterState.approvalDate) {
      case 0: {
        return '준공년도 전체'
      }
      case 1: {
        return '1년 이하'
      }
      case 2: {
        return '5년 이하'
      }
      case 3: {
        return '10년 이하'
      }
      case 4: {
        return '15년 이하'
      }
      case 5: {
        return '15년 이상'
      }
    }
  },
  printItemTypeInfo: (state) => {
    let val = ''
    let dot = ''
    if (state.filterState.itemType.opt1 === 1 || state.filterState.itemType.opt2 === 1 || state.filterState.itemType.opt3 === 1) {
      if (state.filterState.itemType.opt1 === 1) {
        val += dot + '원'
        dot = '/'
      }
      if (state.filterState.itemType.opt2 === 1) {
        val += dot + '투'
        dot = '/'
      }
      if (state.filterState.itemType.opt3 === 1) {
        val += dot + '쓰리+'
        dot = '/'
      }
      val += '룸'
    } else if (state.filterState.itemType.opt4 === 1) {
      val = '빌라분양/매매'
    } else if (state.filterState.itemType.opt5 === 1) {
      val = '상가/사무실'
    }
    if (val === '') val = '매물유형'
    return val
  },
  printSaleTypeInfo: (state) => {
    let val = ''
    let dot1 = ''
    let dot2 = ''
    if (state.filterState.saleType.opt1 === 1 || state.filterState.saleType.opt2 === 1) {
      if (state.filterState.saleType.opt1 === 1) {
        val += dot1 + '월'
        dot1 = '/'
      }
      if (state.filterState.saleType.opt2 === 1) {
        val += dot1 + '전'
        dot1 = '/'
      }
      val += '세'
      dot2 = ','
    }
    if (state.filterState.saleType.opt3 === 1) {
      val += dot2 + '매매'
    }
    if (val === '') val = '거래유형'
    return val
  }
}

// mutations  set 개념
const mutations = { // set 개념
  setPageRoot (state, {root}) {
    state.pageRoot = root
  },
  setDetailViewMode: (state, mode) => {
    if (mode === 'all') {
      state.detailView.viewList = []
      state.detailView.viewList = state.detailView.viewList.concat(state.detailView.data.imgVideoArray, state.detailView.data.imgItemArray, state.detailView.data.img2dArray, state.detailView.data.img3dArray)
    } else if (mode === 'item') {
      state.detailView.viewList = state.detailView.data.imgItemArray
    } else if (mode === '2d') {
      state.detailView.viewList = state.detailView.data.img2dArray
    } else if (mode === '3d') {
      state.detailView.viewList = state.detailView.data.img3dArray
    } else if (mode === 'video') {
      state.detailView.viewList = state.detailView.data.imgVideoArray
    }
    state.detailView.viewMode = mode
  },
  setMapMinLevel: (state, { level }) => {
    if (state.mapObject !== null) {
      // state.mapObject.setLevel(level)
      state.mapObject.setMinLevel(level)
    }
  }
  /*
  pushProductToCart (state, { id }) {
    state.items.push({
      id,
      quantity: 1
    })
  },

  incrementItemQuantity (state, { id }) {
    const cartItem = state.items.find(item => item.id === id)
    cartItem.quantity++
  },

  setCartItems (state, { items }) {
    state.items = items
  },

  setCheckoutStatus (state, status) {
    state.checkoutStatus = status
  }
  */
}

// actions 실질적인 처리를 하는 메소드 개념
const actions = {
  filterSave ({ commit, state }) {
    // console.log('vuex 세이브!')
  },
  filterSaleTypeReset ({ commit, state }) {
    // 거래 유형
    state.filterState.saleType.opt1 = 1
    state.filterState.saleType.opt2 = 1
    state.filterState.saleType.opt3 = 1

    state.filterState.mCost = 0
  },
  filterPriceReset ({ commit, state }) {
    // 가격
    state.filterState.depositStep = [0, 44]
    state.filterState.deposit = [0, -1]
    state.filterState.monthlyStep = [0, 30]
    state.filterState.monthly = [0, -1]
    state.filterState.salePriceStep = [0, 25]
    state.filterState.salePrice = [0, -1]
    state.filterState.m2Step = [0, 10]
    state.filterState.m2 = [0, -1]
  },
  filterReset ({ dispatch, commit, state }) {
    // 거래 유형
    dispatch('filterSaleTypeReset')
    // 가격 리셋
    dispatch('filterPriceReset')
    // 검색
    state.filterState.search = ''
    // 매물 유형
    state.filterState.itemType.opt1 = 1
    state.filterState.itemType.opt2 = 1
    state.filterState.itemType.opt3 = 1
    state.filterState.itemType.opt4 = 0
    state.filterState.itemType.opt5 = 0
    // 매물 구조
    state.filterState.structType.opt1 = 1
    state.filterState.structType.opt2 = 1
    state.filterState.structType.opt3 = 1
    state.filterState.structType.opt4 = 1
    state.filterState.structType.opt6 = 1
    state.filterState.structType.opt7 = 1
    state.filterState.structType.opt8 = 1

    state.filterState.itemFloor.opt1 = 1
    state.filterState.itemFloor.opt8 = 1
    state.filterState.itemFloor.opt9 = 1
    state.filterState.approvalDate = 0
    state.filterState.roomOption.opt1 = 0
    state.filterState.roomOption.opt2 = 0
    state.filterState.roomOption.opt3 = 0
    state.filterState.roomOption.opt4 = 0
    state.filterState.roomOption.opt5 = 0
    // 이미지 모드
    state.filterState.imgOption.opt1 = 0
    state.filterState.imgOption.opt2 = 0
    state.filterState.imgOption.opt3 = 0
    state.filterState.imgOption.opt4 = 0
    state.filterState.imgOption.opt5 = 0
  },
  requestMapData ({ commit, state }, p) {
    return this.requestData(`/rep.map.api`, { 'param': p, 'filter': state.filterState }, {})
  },
  toggleFavorite ({ commit, state }, no) {
    if (state.favoriteList.length > 30) { // 북마크 30개 제한
      EventBus.$emit('alert', '30개 매물 까지만 찜 할수있습니다.')
      return
    }
    const index = state.favoriteList.indexOf(no)
    if (index !== -1) { // 있다면
      state.favoriteList.splice(index, 1)
    } else { // 없다면
      state.favoriteList.push(no)
    }
    localStorage.setItem('favoriteList', JSON.stringify(state.favoriteList))

    this.requestData(`/rep.map.api`, {'param': {'type': 'favoriteList', 'favoriteList': state.favoriteList}, 'filter': state.filterState}, {}).then(data => {
      state.favoriteView.data = data.array
    })
  },
  loadFavoriteList ({ commit, state }) {
    const favoriteList = localStorage.getItem('favoriteList')
    if (favoriteList) {
      state.favoriteList = JSON.parse(favoriteList)
      this.requestData(`/rep.map.api`, {'param': {'type': 'favoriteList', 'favoriteList': state.favoriteList}, 'filter': state.filterState}, {}).then(data => {
        state.favoriteView.data = data.array
      })
    }
  }
  /*
  checkout ({ commit, state }, products) {
    const savedCartItems = [...state.items]
    commit('setCheckoutStatus', null)
    // empty cart
    commit('setCartItems', { items: [] })
    shop.buyProducts(
      products,
      () => commit('setCheckoutStatus', 'successful'),
      () => {
        commit('setCheckoutStatus', 'failed')
        // rollback to the cart saved before sending the request
        commit('setCartItems', { items: savedCartItems })
      }
    )
  },

  addProductToCart ({ state, commit }, product) {
    commit('setCheckoutStatus', null)
    if (product.inventory > 0) {
      const cartItem = state.items.find(item => item.id === product.id)
      if (!cartItem) {
        commit('pushProductToCart', { id: product.id })
      } else {
        commit('incrementItemQuantity', cartItem)
      }
      // remove 1 item from stock
      commit('products/decrementProductInventory', { id: product.id }, { root: true }) // 다른파일 접근 방법 루트방식
    }
  }
  */
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/mapData.js